import React                         from 'react'
import { useDispatch, useSelector }   from 'react-redux'
import PaginationComponent            from '../../player_activity/components/participation_history/pagination_component'
import { useGetRosterQuery }          from '../store/rosterApi'
import { setPage }                    from '../store/filtersSlice'

const RosterPagination = () => {
  const dispatch = useDispatch()
  const filters  = useSelector((state) => state.filters)
  const { data }  = useGetRosterQuery(filters)

  if (!data || data.total_pages <= 1) return null

  return (
    <div className='customer-group-members-pagination text-center add-margin-top-10'>
      <PaginationComponent
        page={ data.current_page }
        elementsCount={ data.total_pages }
        elementsOnPage={ 1 }
        setCurrentPage={ (nr) => dispatch(setPage(nr)) }
      />
    </div>
  )
}

export default RosterPagination
